/**
 * EmployerCandidatesPage.jsx
 * Placeholder at `/employer/candidates`.
 *
 * STRICT OPERATIONAL HONESTY:
 *   No fake candidate lists. No fake counts. No synthetic data.
 *
 * A real candidates-list-across-roles surface needs a backend
 * endpoint that does NOT currently exist (each role has its
 * matches under /employer/roles/{id}/matches; a cross-role
 * aggregation is intentionally deferred).
 *
 * This page acknowledges the surface in the IA and routes the
 * operator to the per-role candidate views.
 */
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users as UsersIcon, ArrowRight, Briefcase } from 'lucide-react';


export default function EmployerCandidatesPage() {
  return (
    <div
      className="mx-auto max-w-3xl py-12 md:py-20 px-4 space-y-6"
      data-testid="employer-candidates-page"
    >
      <header className="space-y-2 text-center">
        <p className="text-[10px] uppercase tracking-[0.24em] text-ndor-gold font-medium">
          Candidates
        </p>
        <h1 className="text-2xl md:text-3xl font-semibold text-ndor-ink">
          Cross-role candidate view
        </h1>
        <p className="text-sm text-ndor-ink-muted leading-relaxed max-w-xl mx-auto">
          A consolidated candidate roster across all of your roles is
          on the way. For now, candidates are surfaced per-role from
          the Roles page.
        </p>
      </header>

      <Card className="border-ndor-edge bg-ndor-surface" data-testid="employer-candidates-empty">
        <CardContent className="py-10 text-center space-y-4">
          <UsersIcon className="mx-auto h-10 w-10 text-ndor-ink-muted opacity-50" />
          <p className="text-sm text-ndor-ink">No cross-role view yet.</p>
          <p className="text-xs text-ndor-ink-muted max-w-md mx-auto">
            Open a role to see its matches, signals, and reviewer
            assignments. Each role is its own decision channel.
          </p>
          <div className="pt-2">
            <Link to="/employer/roles" data-testid="employer-candidates-roles-cta">
              <Button
                size="sm"
                className="bg-ndor-ink text-ndor-surface hover:bg-ndor-ink-muted"
              >
                <Briefcase className="mr-2 h-4 w-4" />
                Open Roles
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
